import React, {Component} from 'react'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl';

import {
  MSG_SHOW_SUCCESS,
  MSG_SHOW_WARNING,
  MSG_SHOW_ERROR,
  MSG_SHOW_INFO
} from '../../../redux/actions/actionTypes'
import styles from './styles'

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose,bgClass } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root + " " + bgClass}>
      <Typography variant="h6" className="msgbox-title" >{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    minWidth:600,
    maxWidth:800,
    textAlign:"center"
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    justifyContent:"center"
  },
}))(MuiDialogActions);


class MsgBoxContainer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isOpen:false,
      msgType:null,
      title:null,
      message:null,
      nexttab:null
    }

    const showError=this.showError.bind(this)
    const showInfo=this.showInfo.bind(this)
    const showSuccess=this.showSuccess.bind(this)
    const showWarning=this.showWarning.bind(this)
    const closeModal = this.closeModal.bind(this)
    this.handleClose=this.handleClose.bind(this)
    this.onKeyUp = this.onKeyUp.bind(this);
    window.setClose = this.setClose.bind(this)

    //emitter.removeAllListeners();

    window.emitter.addListener(MSG_SHOW_ERROR, function(message) {
        showError(message)
    })

    window.emitter.addListener(MSG_SHOW_INFO, function(message) {
        showInfo(message)
    })

    window.emitter.addListener(MSG_SHOW_SUCCESS, function(message, nexttab) {
        showSuccess(message, nexttab)
    })

    window.emitter.addListener(MSG_SHOW_WARNING, function(message) {
        showWarning(message)
    })

    window.addEventListener("keyup", function(event) {
      console.log("event ",event)
      if (event.keyCode === 13) {
       event.preventDefault();
       closeModal();
      }
    });

  }


showError(message){
    this.setState({
      isOpen:true,
      title:"Error",
      msgType:"error",
      message:message,
      nexttab:null
    })
 }

showInfo(message){
  this.setState({
    isOpen:true,
    title:"Infomation",
    msgType:"info",
    message:message,
    nexttab:null
  })
 }
 
showSuccess(message, nexttab){
  this.setState({
    isOpen:true,
    title: "Success",
    msgType:"success",
    message:message,
    nexttab:nexttab
  })
 }

 closeModal(){
      this.setState({isOpen:false})
      if(this.state && this.state.nexttab === "rrsTab5"){
        window.handleMREval()
      }
      if(this.state ){  // next tab
        window.$('#'+this.state.nexttab).collapse({toggle: true});
      }
      
 }

showWarning(message){
  this.setState({
    isOpen:true,
    title:"Warning",
    msgType:"warning",
    message:message,
    nexttab:null
  })
 }
 
handleClose(){
    //this.setState({isOpen:false})
    this.setState({
      isOpen:false,
      msgType:null,
      title:null,
      message:null,
      nexttab:null
    })

    if(this.state && this.state.nexttab === "rrsTab5"){
      window.handleMREval()
    }
  }

setClose(){
  this.setState({isOpen:false})
}

onKeyUp(event) {
  if (event.charCode === 13) {
    this.handleClose();
  }
}

   render() {  
     let { isOpen, msgType, title, message, nexttab } = this.state
     let target = ""
     if (nexttab) {
       target = "#" + nexttab
     }
     
     let bgClass = ""

    switch(msgType){
      case "error" :
        bgClass ="bg-danger"
        break
      case "warning" :
         bgClass ="bg-warning"
         break
      case "info" :
        bgClass ="bg-info"
        break
      case "success" :
         bgClass ="bg-success"
          break
    }

    return(
      <div style={{zIndex:999999}}>
        <FormControl placeholder="First name" onKeyPress={this.onKeyUp} />
        <Dialog  id="msgBoxContainer"  onClose={this.handleClose} aria-labelledby="customized-dialog-title" open={isOpen}>
        
          <DialogTitle id="customized-dialog-title" bgClass={bgClass} onClose={this.handleClose}>
            {title}
          </DialogTitle>
          <DialogContent dividers>
            <Typography className="msgbox-body" gutterBottom>
              <span dangerouslySetInnerHTML={{ __html: message }} />
            </Typography>
          </DialogContent>
          <DialogActions >
            {/* <Button ref={this.refButton} data-toggle="collapse" data-target={target} aria-expanded="false" aria-controls={nexttab} onClick={this.handleClose} >
              <div>
                <img src='../../../assets/images/icons/btn-order-check-green.png' />
                <br />
                <span>ตกลง</span>
              </div>
            </Button> */}
            <a href="#" className="sp-btn-icon btn-ok" data-toggle="collapse" data-target={target} aria-expanded="false" aria-controls={nexttab} onClick={this.handleClose}  onKeyPress={this.onKeyUp} >
              <i className="icon btn-order-check-green" />
              <span className="sp-btn-icon-label">ตกลง</span>
            </a>
          </DialogActions>
          
        </Dialog>
  </div>
    )
  }
}

export default MsgBoxContainer
